import React from "react";
import CustomDateTimeInput from "server/components/Fields/CustomDateTimeInput";

const SuccessfulPayments = ({ handleParamChange }) => {
  return (
    <>
      <CustomDateTimeInput
        label="От"
        source="from"
        required={true}
        onChange={val => handleParamChange("from", val)}
      />

      <CustomDateTimeInput
        label="До"
        source="to"
        required={true}
        onChange={val => handleParamChange("to", val)}
      />
    </>
  );
};

export default SuccessfulPayments;
